/* @flow */

import React from 'react';
import { Item, Message } from 'semantic-ui-react';
import BlockTemplateImage from './BlockTemplateImage';
import { getRenderComponent } from 'edito/plugin';

type Props = {
  templates: Array<EditorialBlockTemplate>,
  blocks: Array<EditorialBlock>,
};

const BlockListRender = ({ templates, blocks }: Props) => {
  const renderContent = block => {
    const component = getRenderComponent(block);
    if (component === null) {
      console.warn(
        `Unknown render block type ${block.template}. Cannot render`
      );
    }

    return component;
  };

  if (blocks && blocks.length) {
    return (
      <Item.Group divided>
        {blocks.map(block => (
          <Item key={block.id}>
            <BlockTemplateImage templates={templates} block={block} />
            <div className="ui middle aligned content">
              {renderContent(block)}
            </div>
          </Item>
        ))}
      </Item.Group>
    );
  }

  return <Message icon="info" header="Aucun contenu éditorial" />;
};

export default BlockListRender;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlockListRender.js